import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import GenericDataTable from "../Shared/DataTable/GenericDataTable.js";
import * as LayoutComponents from '../Shared/LayoutComponents.js'
import TaskManager from '../TaskManager/TaskManager.js';
import { EventEmitter } from "events";

import RelationProductsComplianceStandards from '../RelationProductsComplianceStandards/RelationProductsComplianceStandards.js';
import RelationProductsComplianceRegulations from '../RelationProductsComplianceRegulations/RelationProductsComplianceRegulations.js';

import '../Shared/Style.css';
import "./App.css";



const ItemDetailsPane = ({ globalContext }) => {

    const AppContext = globalContext;
    const [isSavingItem, setIsSavingItem] = useState(false);
    const [isShowingSaveMessage, setIsShowingSaveMessage] = useState(false);
    const [visibleDetailsTab, setVisibleDetailsTab] = useState("information");
    const [itemDetailsPaneActive, setItemDetailsPaneActive] = useState(AppContext.isPaneOpen);
    const [itemDetailsPaneOpenEffect, setItemDetailsPaneOpenEffect] = useState(false);
    const [showItemContextMenu, setShowItemContextMenu] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isChangingArchiveStatus, setIsChangingArchiveStatus] = useState(false);
    const [version, setVersion] = useState(0);

    

    const [errorCurrentItem, setErrorCurrentItem] = useState(false);
    const [hasUDIUnsavedChanges, setHasUDIUnsavedChanges] = useState(false);
    const [hasProductUnsavedChanges, setHasProductUnsavedChanges] = useState(false);
    
    const [isShowingUDIUnsavedChangesWarning, setIsShowingUDIUnsavedChangesWarning] = useState(false);
    const [isShowingProductUnsavedChangesWarning, setIsShowingProductUnsavedChangesWarning] = useState(false);

    AppContext.hasUDIUnsavedChanges = hasUDIUnsavedChanges;
    AppContext.setHasUDIUnsavedChanges = setHasUDIUnsavedChanges;
    AppContext.isShowingUDIUnsavedChangesWarning = isShowingUDIUnsavedChangesWarning;
    AppContext.setIsShowingUDIUnsavedChangesWarning = setIsShowingUDIUnsavedChangesWarning;

    AppContext.hasProductUnsavedChanges = hasProductUnsavedChanges;
    AppContext.setHasProductUnsavedChanges = setHasProductUnsavedChanges;
    AppContext.isShowingProductUnsavedChangesWarning = isShowingProductUnsavedChangesWarning;
    AppContext.setIsShowingProductUnsavedChangesWarning = setIsShowingProductUnsavedChangesWarning;



    const contextMenuButton = useRef(null);
    const contextMenu = useRef(null);
    const versionsMenuButton = useRef(null);
    const versionsMenuOptions = useRef(null);



    
    const isNullOrEmpty = (val) => {
        return val === "" || val === null;
    }

    const hasValue = (val) => {
        return val !== "" && val !== null;
    }
        
        

    function stringifyIfObject(value) {
        if (typeof value === "object" && value !== null) {
            return JSON.stringify(value);
        }
            return value;
    }



    const validFormField = (title, field) => {

        if (field == "SKUProductCode") {
            if (isNullOrEmpty(AppContext.currentItem[field])) {
                setErrorCurrentItem(title + " is a mandatory field"); return false;
            }
        }

        if (field == "ProductName") {
            if (isNullOrEmpty(AppContext.currentItem[field])) {
                setErrorCurrentItem(title + " is a mandatory field"); return false;
            }
        }



        return true;

    }


    const saveCurrentItem = () => {
        // Validations

        let isValidForm = true;

        setErrorCurrentItem(false);

        if (!validFormField("Product Family Name", "Name")) isValidForm = false;

        if (!isValidForm) return false;

        setIsSavingItem(true);
        setIsShowingSaveMessage(false);

        // Update item remotely and if successful...

        let currentItem = JSON.parse(JSON.stringify(AppContext.currentItem));

        //currentItem.Entities = AppContext.linkedObjectsList;



        let updateItemURL = AppContext.dataUrl;


        const formData = new FormData();

        const appendToFormData = (formData, data, parentKey = "") => {

            // 0. Handle File / Blob FIRST (critical)
            if (data instanceof File || data instanceof Blob) {
                formData.append(parentKey, data);
                return;
            }


            // 1. Handle arrays (INCLUDING empty arrays)
            if (Array.isArray(data)) {
                if (data.length === 0) {
                    // IMPORTANT: preserve empty array explicitly
                    formData.append(parentKey, JSON.stringify([]));
                    return;
                }

                data.forEach((item, index) => {
                    appendToFormData(formData, item, `${parentKey}[${index}]`);
                });

                return;
            }

            // 2. Handle objects
            if (typeof data === "object" && data !== null) {
                Object.keys(data).forEach((key) => {
                    const fullKey = parentKey ? `${parentKey}.${key}` : key;
                    appendToFormData(formData, data[key], fullKey);
                });
                return;
            }

            // 3. Primitive values (including null/undefined safety)
            formData.append(parentKey, data ?? "");
        };

        appendToFormData(formData, AppContext.currentItem);

        

        let requestOptions = {
            method: "PUT",
            body: formData
        };

        fetch(updateItemURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Id) {

                    // Update the item in the existing item array
                    const updatedDataArray = AppContext.data.map((item) =>
                        item.Id === result.Id ? result : item
                    );
                    AppContext.setData(updatedDataArray);


                    // Update current item
                    AppContext.setCurrentItem(result);

                    // Update local original item to use when cancelling edit
                    AppContext.setOriginalItem(result);

                    setIsShowingSaveMessage(true);

                    setIsEditMode(false);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingItem(false);
            });
    };









    const checkResponseError = (response) => {

        if (!response.ok) {
            if (response.status === 401)
                document.dispatchEvent(new Event("api:unauthorized"));

            throw new Error("Network response was not ok");
        }

    }



    // On parent change of the details pane status "restart" the popup
    useEffect(() => {

        if (AppContext.isPaneOpen == true) {
            // Immediately activate popup, but wait a bit to trigger the open animation
            setItemDetailsPaneActive(true);
            setTimeout(() => { setItemDetailsPaneOpenEffect(true); }, 100);
        }
        else {
            // Immediately do the hide effect but wait 300 to deactivate the popup
            setItemDetailsPaneOpenEffect(false);
            setTimeout(() => { setItemDetailsPaneActive(false); }, 300);
        }

    }, [AppContext.isPaneOpen]);


    const reinitialize = () => {
        changeTab("information");
        setIsSavingItem(false);
        AppContext.setIsShowingDeleteConfirmation(false);

        setIsShowingSaveMessage(false);

        setIsEditMode(false);


    }

    useEffect(() => {

        if (itemDetailsPaneActive)
            reinitialize();

    }, [itemDetailsPaneActive]);


    useEffect(() => {

        if(!itemDetailsPaneOpenEffect)
            setShowItemContextMenu(false);

    }, [itemDetailsPaneOpenEffect])




    const openContextualMenu = () => {
        setShowItemContextMenu(!showItemContextMenu);
    };



    useEffect(() => {

        const handleClickOutside = (e) => {

            if (contextMenuButton.current && contextMenuButton.current.contains(e.target) ||
                contextMenu.current && contextMenu.current.contains(e.target) ||
                versionsMenuButton.current && versionsMenuButton.current.contains(e.target) ||
                versionsMenuOptions.current && versionsMenuOptions.current.contains(e.target)
            )
                return;

            setShowItemContextMenu(false);
            AppContext.setIsShowingDeleteConfirmation(false);

        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    




    // Canceling edit changes
    const cancelEdit = () => {

        AppContext.setCurrentItem(AppContext.originalItem);
        setIsEditMode(false);
        setVersion(v => v + 1);

    }




    const toggleEditMode = () => {

        setIsEditMode(!isEditMode);

        setIsShowingSaveMessage(false);
    }



    const changeTab = (tab) => {

        
        setIsShowingSaveMessage(false);

        setVisibleDetailsTab(tab);


    }


    const closePane = () => {

        AppContext.closePane();

    }




    

    const deepEqual = (a, b) => {
        if (a === b) return true;

        if (
            typeof a !== "object" || a === null ||
            typeof b !== "object" || b === null
        ) {
            return false;
        }

        const keysA = Object.keys(a);
        const keysB = Object.keys(b);

        if (keysA.length !== keysB.length) return false;

        for (let key of keysA) {
            if (!keysB.includes(key)) return false;

            if (!deepEqual(a[key], b[key])) return false;
        }

        return true;
    };



    // Avoid losing unsaved changes

    useEffect(() => {

        if (!deepEqual(AppContext.currentItem, AppContext.originalItem))
            AppContext.setHasProductUnsavedChanges(true);
        else
            AppContext.setHasProductUnsavedChanges(false);

    }, [AppContext.currentItem, AppContext.originalItem]);






    const tabs = [
        { title: "Product Family Details", tab: "information" },
        { title: "Products", tab: "products" },
        { title: "Standards", tab: "standards" },
        { title: "Regulations", tab: "regdocs" },
        { title: "Tasks", tab: "tasks" },
    ];


    const displayFieldOnly = true;

    let fullWidthPane = true;

    return (
        <>

            {itemDetailsPaneActive ? 
                
                <div
                    style={{ height: "100vh", overflow: "auto", backgroundColor: "#f7fafc" }}
                    className={`${fullWidthPane ? "slide-pane-full-width" : "slide-pane"} ${itemDetailsPaneOpenEffect ? "open" : ""}`}
                >
                    <div className="content">

                        
                        <p style={{ color: "#555", fontSize: "11px" }}>
                            <span className="breadcrumb-link" style={{ marginRight: "5px" }} onClick={() => closePane()}>Product Families</span>
                            {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? null :
                                <>
                                    &gt; <span style={{ marginLeft: "5px" }}> {AppContext.currentItem.Name}</span>
                                </>
                            }
                        </p>
                        


                        

                        {/* NEW LAYOUT */}
                        {/* NEW LAYOUT */}
                        {/* NEW LAYOUT */}



                        <div className="item-details-content">

                            <div className="item-details-content-tabs">

                                <div className="nav" style={{ display: "flex", flexDirection: "column", gap: "4px" }} >

                                    {tabs.map((tab, index) => {
                                        if (tab.onlyAdmin && AppContext.userRole !== "Admin") {
                                            return null;
                                        }

                                        return (
                                            <a
                                                key={index} // better than index if tab.tab is unique
                                                onClick={() => changeTab(tab.tab)}
                                                className={`nav-item item-details-menu-tab ${visibleDetailsTab === tab.tab ? "active" : ""
                                                    }`}
                                            >
                                                {tab.title}
                                            </a>
                                        );
                                    })}

                                </div>

                            </div>




                            <div className="item-details-content-content">

                                {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? (
                                    <>
                                        <LayoutComponents.PageLoading />
                                    </>
                                ) : (
                                    <>


                                        {/* Header */}

                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                                <h2 style={{ margin: 0, fontSize: "24px", fontWeight: 700, color: "#1a202c", display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <i className="fas fa-box-open" style={{ color: "#2b6cb0" }} />
                                                    Product Family Details
                                                </h2>

                                                <span style={{ fontSize: "16px", color: "#4a5568", fontWeight: 600, background: "#edf2f7", padding: "4px 12px", borderRadius: "6px" }}>
                                                    {AppContext.currentItem.Name}
                                                </span>

                                            </div>

                                            <div style={{ display: "flex", gap: "8px" }}>

                                                {visibleDetailsTab == "information" ? <>

                                                    {AppContext.userRole == "Admin" ? <>

                                                    {isEditMode ?

                                                        <div id="buttom-bar" >

                                                            {/* FORMS BUTTONS */}

                                                            <div className="action-button-bar" style={{ marginTop: "0px" }}>

                                                                <div className="action-button-bar-left"></div>
                                                                <div className="action-button-bar-center"></div>

                                                                <div className="action-button-bar-right">

                                                                    {!isSavingItem ? (
                                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "right", gap: "8px" }}>
                                                                            <button
                                                                                className="action-button save-button"
                                                                                onClick={() => cancelEdit()}
                                                                                onMouseOver={(e) => {
                                                                                    e.currentTarget.style.backgroundColor = "#f8f9fa";
                                                                                    e.currentTarget.style.borderColor = "#c1c4c8";
                                                                                }}
                                                                                onMouseOut={(e) => {
                                                                                    e.currentTarget.style.backgroundColor = "#ffffff";
                                                                                    e.currentTarget.style.borderColor = "#dee2e6";
                                                                                }}
                                                                                style={{
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    padding: "6px 14px",
                                                                                    cursor: "pointer",
                                                                                    transition: "all 0.2s ease-in-out",
                                                                                    color: "#5f6368",
                                                                                    border: "1px solid #dee2e6",
                                                                                    backgroundColor: "#ffffff",
                                                                                    whiteSpace: "nowrap",
                                                                                    outline: "none"
                                                                                }}
                                                                            >
                                                                                Cancel
                                                                            </button>
                                                                            <button
                                                                                className="action-button save-button"
                                                                                onClick={saveCurrentItem}
                                                                            >
                                                                                Save
                                                                            </button>
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            <LoadingSpinnerImage />
                                                                        </>
                                                                    )}


                                                                </div>


                                                            </div>

                                                        </div>

                                                        :
                                                        <>
                                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                                <div style={{
                                                                    flex: 1,
                                                                    justifyContent: "right",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    marginRight: "20px",
                                                                }}>
                                                                    {isShowingSaveMessage ?
                                                                        <span className="save-message-shown">
                                                                            Save successful!
                                                                        </span>
                                                                        : null}
                                                                </div>

                                                                <div>
                                                                    <div className="view-task-field" style={{
                                                                        textAlign: "right",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        marginBottom: "0px",
                                                                    }}>
                                                                        <span onClick={() => toggleEditMode()} value="EDIT" style={{ borderRadius: "20px" }} className="edit-rims-edit-button">
                                                                            <i className="far fa-edit pointer g-mr-8"></i>Edit Product Family
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>



                                                        </>
                                                    }

                                                </>

                                                        : null}
                                                    </>

                                                : null}


                                                    <button ref={contextMenuButton} onClick={openContextualMenu} style={{ border: "1px solid #cbd5e0", background: "white", borderRadius: "6px", padding: "6px 10px", cursor: "pointer", color: "#4a5568" }}>
                                                    <i className="fas fa-ellipsis-v" />
                                                </button>

                                                <button onClick={() => closePane()} style={{ border: "1px solid #cbd5e0", background: "white", borderRadius: "6px", padding: "6px 10px", cursor: "pointer", color: "#4a5568" }}>
                                                    <i className="fas fa-times" />
                                                </button>
                                            </div>
                                        </div>



                                        {/* Main content */}


                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>


                                            {/* INFORMATION DASHBOARD */}

                                            {visibleDetailsTab == "information" ? <>

                                                {/* LEFT */}

                                                <div style={{ flex: 1, minWidth: "400px", display: "flex", flexDirection: "column", gap: "24px" }}>



                                                    <LayoutComponents.InfoBlock>
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>


                                                            <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>

                                                                <div style={{width: "50%", display: "flex", alignItems: "center", justifyContent: "center"}}>
                                                                        
                                                                    <FieldTypes.ItemDetailsField_Image AppContext={AppContext} fieldName={"File"} urlFieldName={"Image"} fieldTitle={"Product Family Image"} fieldRemoveStatus={"DeleteImage"} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                            
                                                                </div>

                                                                <div style={{ width: "50%", marginLeft: "40px"}}>
                                                                    <div style={{marginBottom: "20px"}}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Product Family Name
                                                                        </span>
                                                                        <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>
                                                                            <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"Name"} fieldTitle={"Product Family Name"} mandatory={true} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                        </span>
                                                                    </div>

                                                                        
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </LayoutComponents.InfoBlock>



                                                    
                                                    <LayoutComponents.InfoBlock>
                                                        <h4 style={{ margin: "0 0 16px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096" }}>
                                                            Custom Fields
                                                        </h4>
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                                            {/* CUSTOM USER FIELDS */}
                                                            {/* CUSTOM USER FIELDS */}
                                                            {/* CUSTOM USER FIELDS */}
                                                            {AppContext.enableCustomFields ?
                                                                <FieldTypes.FieldType_CustomUserFieldsView key={`custom_fields_${version}`} globalContext={AppContext} isEditing={isEditMode} />
                                                                    : null}

                                                            {AppContext.currentItem?.CustomFields?.length ? null : "No custom fields"}
                                                        </div>
                                                    </LayoutComponents.InfoBlock>


                                                </div>



                                                {/* RIGHT */}

                                                <div style={{ flex: 1, minWidth: "280px", display: "flex", flexDirection: "column", gap: "24px" }}>

                                                    <LayoutComponents.InfoBlock>

                                                        <h4 style={{ margin: "0 0 20px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096", borderBottom: "1px solid #edf2f7", paddingBottom: "10px" }}>
                                                                Analytics
                                                        </h4>

                                                        <div style={{ display: "flex", flexDirection: "row", gap: "20px", flexWrap: "wrap" }}>

                                                            <div style={{ flex: 1 }}>
                                                                <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                    Products
                                                                </span>
                                                                <span style={{
                                                                    fontSize: "20px",
                                                                    fontWeight: 600,
                                                                    color: AppContext.currentItem?.ProductCount > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                    display: "block",
                                                                    lineHeight: 1
                                                                    }}>
                                                                        <span className="pointer" onClick={() => changeTab("products")}>{AppContext.currentItem?.ProductCount ?? 0}</span>
                                                                </span>
                                                            </div>

                                                            <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "40px" }}>
                                                                <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                    Standards
                                                                </span>
                                                                <span style={{
                                                                    fontSize: "20px",
                                                                    fontWeight: 600,
                                                                    color: AppContext.currentItem?.StandardsCount > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                    display: "block",
                                                                    lineHeight: 1
                                                            }}>
                                                                    <span className="pointer" onClick={() => changeTab("standards")}>{AppContext.currentItem?.StandardsCount ?? 0}</span>

                                                                </span>
                                                            </div>
                                                                   
                                                            <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "40px" }}>
                                                                <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                    Regulations
                                                                </span>
                                                                <span style={{
                                                                    fontSize: "20px",
                                                                    fontWeight: 600,
                                                                    color: AppContext.currentItem?.RegulatoryDocumentsCount > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                    display: "block",
                                                                    lineHeight: 1
                                                            }}>
                                                                    <span className="pointer" onClick={() => changeTab("regdocs")}>{AppContext.currentItem?.RegulatoryDocumentsCount ?? 0}</span>

                                                                </span>
                                                            </div>

                                                            <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "40px" }}>
                                                                <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                    Tasks
                                                                </span>
                                                                <span style={{
                                                                    fontSize: "20px",
                                                                    fontWeight: 600,
                                                                    color: AppContext.currentItem?.TaskCount > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                    display: "block",
                                                                    lineHeight: 1
                                                            }}>
                                                                    <span className="pointer" onClick={() => changeTab("tasks")}>{AppContext.currentItem?.TaskCount ?? 0}</span>

                                                                </span>
                                                            </div>

                                                        </div>
                                                    
                                                    </LayoutComponents.InfoBlock>

                                                </div>

                                            </> : null}





                                            {/* PRODUCTS */}

                                            {visibleDetailsTab == "products" && <>
                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>


                                                    <GenericDataTable
                                                        columns={[
                                                            {
                                                                key: "Id",
                                                                label: "",
                                                                sortable: false,
                                                                type: "checkbox",
                                                                size: "60px",
                                                            },

                                                            {
                                                                key: "SKUProductCode",
                                                                label: "SKU",
                                                                sortable: true,
                                                                size: "150px",

                                                                render: ({ row, value }) => (
                                                                    <div
                                                                        style={{
                                                                            padding: "12px",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            whiteSpace: "nowrap",
                                                                        }}
                                                                    >
                                                                        <a
                                                                            href={`/your-medboard/products/?productId=${row.Id}`}
                                                                            style={{
                                                                                color: "#203864",
                                                                                textDecoration: "none",
                                                                            }}
                                                                        >
                                                                            {value}
                                                                        </a>
                                                                    </div>
                                                                ),
                                                            },

                                                            {
                                                                key: "ProductName",
                                                                label: "Product Name",
                                                                sortable: true,
                                                                size: "300px",

                                                                render: ({ row, value }) => (
                                                                    <div
                                                                        style={{
                                                                            padding: "12px",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            whiteSpace: "nowrap",
                                                                        }}
                                                                    >
                                                                        <a
                                                                            href={`/your-medboard/products/?productId=${row.Id}`}
                                                                            style={{
                                                                                color: "#203864",
                                                                                textDecoration: "none",
                                                                            }}
                                                                        >
                                                                            {value}
                                                                        </a>
                                                                    </div>
                                                                ),
                                                            },

                                                            {
                                                                key: "RegistrationsCount",
                                                                label: "Registrations",
                                                                sortable: true,
                                                                size: "150px",

                                                                render: ({ row, value }) => (
                                                                    <div
                                                                        style={{
                                                                            padding: "12px",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            whiteSpace: "nowrap",
                                                                        }}
                                                                    >
                                                                        <a
                                                                            href={`/your-medboard/country-registrations/product-portfolio/product-registrations/?productId=${row.Id}`}
                                                                            style={{
                                                                                color: "#203864",
                                                                                textDecoration: "none",
                                                                            }}
                                                                        >
                                                                            {value}
                                                                        </a>
                                                                    </div>
                                                                ),
                                                            },
                                                        ]}
                                                        fetchUrl="/umbraco/api/RIMSProducts/FamilyProducts/"
                                                        enableDelete={AppContext.userRole == "Admin" ? true : false}
                                                        deleteUrl="/umbraco/api/RIMSProducts/BulkProducts/?productIds="
                                                        exportUrl="/umbraco/api/RIMSProducts/ProductsExport/?productIds="
                                                        queryParams={{ familyId: AppContext.currentItem.Id }}
                                                        exportFileName={`${AppContext.currentItem.Name}-products-export.xlsx`}
                                                        rowTitleKey="ProductName"
                                                        searchPlaceholder="Search Product"
                                                        LoadingComponent={LoadingSpinnerImage}
                                                    />



                                                </div>
                                            </>}




                                            {/* STANDARDS */}

                                            {visibleDetailsTab == "standards" && <>
                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>

                                                    <ProductFamilyStandardsTable AppContext={AppContext} />

                                                </div>
                                            </>}




                                            {/* REGULATORY DOCUMENTS */}

                                            {visibleDetailsTab == "regdocs" && <>
                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>

                                                    <ProductFamilyRegulatoryDocumentsTable AppContext={AppContext} />

                                                </div>
                                            </>}



                                            
                                            {/* TASKS */}

                                            {visibleDetailsTab == "tasks" &&

                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>
                                                    <LayoutComponents.InfoBlock>

                                                        <TaskManager
                                                            emitter={new EventEmitter()}
                                                            paramEntityType="product-family"
                                                            paramEntityId={AppContext.currentItem.Id}
                                                            paramCompanyId={AppContext.currentCompanyId}
                                                            paramUserId={AppContext.currentUserId}
                                                            paramIsSlimVersion={true}
                                                            paramExternalLinkedObjects={[{ EntityType: "product-family", EntityId: AppContext.currentItem.Id }]}
                                                            paramHasLimitedWidth={true} />

                                                    </LayoutComponents.InfoBlock>
                                                </div>
                                            }




                                        </div>




                                    </>)}

                            </div>


                        </div>




                    </div>
                </div>
            
            : null}



            




            {showItemContextMenu && (
                <div
                    ref={contextMenu}
                    style={{
                        position: "fixed",
                        top: `50px`,
                        right: `70px`,
                        background: "white",
                        border: "1px solid #ccc",
                        padding: "4px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        zIndex: 1000,
                        borderRadius: "15px",

                    }}
                >

                    {/* DELETE */}
                    {AppContext.userRole === "Admin" ? (
                        !AppContext.isShowingDeleteConfirmation ? (
                            <div className="context-menu-option" onClick={() => AppContext.setIsShowingDeleteConfirmation(true)}>
                                <i className="far fa-trash-alt"></i> Delete this item
                            </div>
                        ) : (
                            AppContext.isDeletingItem ? (
                                <LoadingSpinnerImage />
                            ) : (
                                <div className="context-menu-option context-delete-option" onClick={AppContext.deleteCurrentItem}>
                                    <i className="far fa-trash-alt"></i> Confirm delete?
                                </div>
                            )
                        )
                    ) : (
                        <div className="context-menu-option disabled">
                            <i className="far fa-trash-alt"></i> Delete (No Permission)
                        </div>
                    )}


                </div>
            )}









        </>
    );
};











const ProductFamilyStandardsTable = ({ AppContext }) => {

    return (
        <div id="standards">
            <div className="product-view-block" style={{ backgroundColor: "white" }}>

                <RelationProductsComplianceStandards productFamilyId={AppContext.currentItem.Id} showTitleAsSubTitle />

            </div>
        </div>
    );
};





const ProductFamilyRegulatoryDocumentsTable = ({ AppContext }) => {

    return (

        <div id="regdocs">
            <div className="product-view-block" style={{ backgroundColor: "white" }}>

                <RelationProductsComplianceRegulations productFamilyId={AppContext.currentItem.Id} showTitleAsSubTitle />

            </div>
        </div>

    );
};





const FamilyProducts = ({ familyId, familyName }) => {

    

    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(1);

    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);

    const [hasMore, setHasMore] = useState(true);

    const [searchInput, setSearchInput] = useState("");
    const [search, setSearch] = useState("");

    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState("ASCENDING");

    const [selectedIds, setSelectedIds] = useState([]);
    const [allLoaded, setAllLoaded] = useState(false);

    const [modalType, setModalType] = useState(null);

    const [loadingAll, setLoadingAll] = useState(false);
    const [actionLoading, setActionLoading] = useState(false);
    const [actionError, setActionError] = useState(null);

    const observerRef = useRef(null);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setRows([]);
            setSelectedIds([]);
            setAllLoaded(false);
            setSearch(searchInput);
        }, 500);

        return () => clearTimeout(timeout);
    }, [searchInput]);

    const columns = [
        { key: "Id", label: "", sortable: false, type: "checkbox" },
        { key: "SKUProductCode", label: "SKUProductCode", sortable: true, type: "text" },
        { key: "ProductName", label: "ProductName", sortable: true, type: "text" },
        { key: "RegistrationsCount", label: "RegistrationsCount", sortable: true, type: "text" },
    ];

    const gridTemplateColumns = "60px 1fr 2fr 1fr";

    const fetchData = useCallback(
        async ({ pageToLoad, reset = false, returnAll = false }) => {
            try {
                setLoading(true);

                const params = new URLSearchParams({
                    page: pageToLoad,
                    familyId: familyId,
                });

                if (search) {
                    params.append("search", search);
                }

                if (sortColumn) {
                    params.append("sortBy", sortColumn);
                    params.append("sortType", sortOrder);
                }

                if (returnAll) {
                    params.append("returnAll", "true");
                }

                const response = await fetch(
                    `/umbraco/api/RIMSProducts/FamilyProducts/?${params.toString()}`
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch");
                }

                const result = await response.json();

                const data = Array.isArray(result)
                    ? result
                    : [];

                setRows((prev) =>
                    reset
                        ? data
                        : [...prev, ...data]
                );

                setHasMore(data.length > 0);

                return data;

            } catch (error) {
                console.error(error);
                return [];
            } finally {
                setLoading(false);
                setInitialLoading(false);
            }
        },
        [search, sortColumn, sortOrder, familyId]
    );

    useEffect(() => {
        setPage(1);
        setHasMore(true);

        fetchData({
            pageToLoad: 1,
            reset: true,
        });
    }, [search, sortColumn, sortOrder, fetchData]);

    const lastRowRef = useCallback(
        (node) => {
            if (loading) return;

            if (observerRef.current) {
                observerRef.current.disconnect();
            }

            observerRef.current = new IntersectionObserver(
                (entries) => {
                    if (
                        entries[0].isIntersecting &&
                        hasMore &&
                        !allLoaded
                    ) {
                        setPage((prevPage) => {

                            const nextPage = prevPage + 1;

                            fetchData({
                                pageToLoad: nextPage,
                            });

                            return nextPage;
                        });
                    }
                },
                {
                    threshold: 0.1,
                    rootMargin: "300px",
                }
            );

            if (node) {
                observerRef.current.observe(node);
            }
        },
        [loading, hasMore, page, fetchData, allLoaded]
    );

    const handleSort = (column) => {
        if (!column.sortable) return;

        setRows([]);
        setSelectedIds([]);
        setAllLoaded(false);

        if (sortColumn === column.key) {
            setSortOrder((prev) =>
                prev === "ASCENDING"
                    ? "DESCENDING"
                    : "ASCENDING"
            );
        } else {
            setSortColumn(column.key);
            setSortOrder("ASCENDING");
        }
    };

    const toggleRowSelection = (id) => {
        setSelectedIds((prev) => {
            if (prev.includes(id)) {
                return prev.filter((x) => x !== id);
            }

            return [...prev, id];
        });
    };

    const handleGlobalCheckbox = async () => {

        const allCurrentlySelected =
            rows.length > 0 &&
            selectedIds.length === rows.length;

        if (allCurrentlySelected) {
            setSelectedIds([]);
            return;
        }

        if (!allLoaded) {

            try {

                setLoadingAll(true);

                /**
                 * IMPORTANT:
                 * We send the NEXT page, not page 1
                 * because backend continues from current paging state.
                 */
                const nextPage = page + 1;

                const allData = await fetchData({
                    pageToLoad: nextPage,
                    returnAll: true,
                });

                /**
                 * If backend returns nothing → everything already loaded
                 */
                if (!allData || allData.length === 0) {

                    setAllLoaded(true);
                    setHasMore(false);

                    // just select everything already visible
                    setSelectedIds(rows.map((x) => x.Id));

                    return;
                }

                /**
                 * Append results (DO NOT replace existing rows)
                 */
                setRows((prev) => {
                    const map = new Map();

                    prev.forEach((x) => map.set(x.Id, x));
                    allData.forEach((x) => map.set(x.Id, x));

                    const merged = Array.from(map.values());

                    setSelectedIds(merged.map((x) => x.Id));

                    return merged;
                });

                /**
                 * Merge selection too
                 */
                setSelectedIds((prev) => {
                    const set = new Set(prev);
                    allData.forEach((x) => set.add(x.Id));
                    return Array.from(set);
                });

                setPage(nextPage);

                /**
                 * If backend returned partial or full remaining set,
                 * we assume more *may* exist until it returns empty once.
                 */
                setHasMore(true);

                setAllLoaded(true);

            } finally {
                setLoadingAll(false);
            }

            return;
        }

        setSelectedIds(rows.map((x) => x.Id));
    };



    function TextCell({ value, href }) {
        return (
            <div style={{ padding: "12px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {href ? (
                    <a
                        href={href}
                        style={{ color: "#203864", textDecoration: "none" }}
                    >
                        {value}
                    </a>
                ) : (
                    value
                )}
            </div>
        );
    }


    const renderCell = (column, row) => {

        if (column.type === "checkbox") {
            return (
                <div style={{ padding: "12px", display: "flex", justifyContent: "center" }}>
                    <input
                        type="checkbox"
                        checked={selectedIds.includes(row.Id)}
                        onChange={() => toggleRowSelection(row.Id)}
                    />
                </div>
            );
        }

        const value = row[column.key];

        let href = null;

        if (column.key == "SKUProductCode") href = `/your-medboard/products/?productId=${row.Id}`;
        if (column.key == "ProductName") href = `/your-medboard/products/?productId=${row.Id}`;
        if (column.key == "RegistrationsCount") href = `/your-medboard/country-registrations/product-portfolio/product-registrations/?productId=${row.Id}`;


        return (
            <TextCell
                value={value}
                href={href}
            />
        );
    };




    const selectedRows = rows.filter((x) =>
        selectedIds.includes(x.Id)
    );
    const handleConfirmAction = async () => {

        try {

            setActionLoading(true);
            setActionError(null);

            const ids = selectedIds.join(",");

            const endpoint =
                modalType === "delete"
                    ? `/umbraco/api/RIMSProducts/BulkProducts/?productIds=${ids}`
                    : `/umbraco/api/RIMSProducts/ProductsExport/?productIds=${ids}`;

            const response = await fetch(endpoint, {
                method: modalType === "delete"
                    ? "DELETE"
                    : "GET",
            });

            if (!response.ok) {
                throw new Error("Request failed");
            }

            /**
             * DELETE
             */
            if (modalType === "delete") {

                setRows((prev) =>
                    prev.filter(
                        (x) => !selectedIds.includes(x.Id)
                    )
                );

                setSelectedIds([]);
            }

            /**
             * EXPORT
             */
            if (modalType === "export") {

                const blob = await response.blob();

                const url =
                    window.URL.createObjectURL(blob);

                const a = document.createElement("a");

                a.href = url;
                a.download = familyName + "-products-export.xlsx";

                document.body.appendChild(a);

                a.click();

                a.remove();

                window.URL.revokeObjectURL(url);
            }

            setModalType(null);

        } catch (error) {

            console.error(error);

            setActionError(
                modalType === "delete"
                    ? "Failed to delete selected products."
                    : "Failed to export selected products."
            );

        } finally {

            setActionLoading(false);
        }
    };


    useEffect(() => {

        if (!modalType) {
            setActionError(null);
            setActionLoading(false);
        }

    }, [modalType]);


    return (
        <div
            style={{ width: "100%", height: "calc(100vh - 250px)", overflow: "hidden", display: "flex", flexDirection: "column", fontFamily: "Arial", background: "#fff" }}
        >

            {/* TOP BAR */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 0", gap: "12px" }}>

                {/* SEARCH */}
                <div
                    className="search-input"
                    style={{ padding: "4px", borderRadius: "15px", border: "1px solid #c0c0c0", width: "40%", display: "flex", flexDirection: "row", alignItems: "center", background: "#fff", boxSizing: "border-box" }}
                >
                    <span
                        className="search-icon"
                        style={{ paddingLeft: "6px", paddingRight: "6px", color: "#777", display: "flex", alignItems: "center" }}
                    >
                        <i className="fas fa-search"></i>
                    </span>

                    <input
                        type="text"
                        placeholder="Search Product"
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        style={{ width: "100%", padding: "8px", outline: "none", border: "none", background: "transparent", boxSizing: "border-box", fontSize: "14px", height: "21px" }}
                    />
                </div>

                {/* ACTIONS */}
                <div style={{ display: "flex", flexDirection: "row" }}>

                    {/* DELETE */}
                    <div style={{ display: "inline-flex", marginRight: "15px" }}>
                        <span
                            className="pointer"
                            onClick={() => {
                                if (selectedIds.length === 0) return;
                                setModalType("delete");
                            }}
                            style={{
                                color: selectedIds.length === 0
                                    ? "#999"
                                    : "rgb(183, 27, 17)",
                                padding: "7px 20px",
                                border: "1px solid rgb(222, 226, 230)",
                                borderRadius: "15px",
                                backgroundColor: "rgb(248, 249, 250)",
                                fontWeight: 500,
                                display: "inline-flex",
                                alignItems: "center",
                                transition: "0.2s",
                                cursor: selectedIds.length === 0
                                    ? "not-allowed"
                                    : "pointer",
                                boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px",
                                opacity: selectedIds.length === 0 ? 0.6 : 1,
                            }}
                        >
                            <i
                                className="fas fa-trash-alt g-mr-8"
                                style={{ marginRight: "8px" }}
                            ></i>

                            Delete
                        </span>
                    </div>

                    {/* EXPORT */}
                    <div style={{ display: "inline-flex", marginRight: "15px" }}>
                        <span
                            className="pointer"
                            onClick={() => {
                                if (selectedIds.length === 0) return;
                                setModalType("export");
                            }}
                            style={{
                                color: selectedIds.length === 0
                                    ? "#999"
                                    : "rgb(32, 56, 100)",
                                padding: "7px 20px",
                                border: "1px solid rgb(222, 226, 230)",
                                borderRadius: "15px",
                                backgroundColor: "rgb(248, 249, 250)",
                                fontWeight: 500,
                                display: "inline-flex",
                                alignItems: "center",
                                transition: "0.2s",
                                cursor: selectedIds.length === 0
                                    ? "not-allowed"
                                    : "pointer",
                                boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px",
                                opacity: selectedIds.length === 0 ? 0.6 : 1,
                            }}
                        >
                            <i
                                className="fas fa-file-excel g-mr-8"
                                style={{ marginRight: "8px" }}
                            ></i>

                            Export
                        </span>
                    </div>

                </div>

            </div>

            {/* HEADER */}
            <div
                style={{ display: "grid", gridTemplateColumns, background: "#f8f8f8", position: "sticky", top: 0, zIndex: 10, flexShrink: 0 }}
            >
                {columns.map((column) => (

                    <div
                        key={column.key}
                        onClick={() => handleSort(column)}
                        style={{ padding: "14px 12px", fontWeight: 600, cursor: column.sortable ? "pointer" : "default", userSelect: "none", textAlign: column.key == "Id" ? "center" : "left" }}
                    >

                        {column.type === "checkbox" ? (
                            loadingAll ? (
                                <div>
                                    <LoadingSpinnerImage small={true} />
                                </div>
                            ) : (
                                <input
                                    type="checkbox"
                                    checked={
                                        rows.length > 0 &&
                                        selectedIds.length === rows.length
                                    }
                                    onChange={handleGlobalCheckbox}
                                />
                            )
                        ) : (
                            <>
                                {column.label}

                                {sortColumn === column.key && (
                                    <span style={{ marginLeft: 8 }}>
                                        {sortOrder === "ASCENDING" ? "↑" : "↓"}
                                    </span>
                                )}
                            </>
                        )}
                    </div>
                ))}
            </div>

            {/* RESULTS */}
            <div style={{ overflowY: "auto", flex: 1 }}>

                {initialLoading ? (
                    <LoadingSpinnerImage />
                ) : (
                    <>
                        {Array.isArray(rows) && rows.map((row, index) => {

                            const isLast =
                                index === rows.length - 1;

                            return (
                                <div
                                    key={row.Id}
                                    ref={isLast ? lastRowRef : null}
                                    style={{ display: "grid", gridTemplateColumns, borderBottom: "1px solid #f1f1f1" }}
                                >
                                    {columns.map((column) => (
                                        <div key={column.key}>
                                            {renderCell(column, row)}
                                        </div>
                                    ))}
                                </div>
                            );
                        })}

                        {loading && rows.length > 0 && (
                            <LoadingSpinnerImage />
                        )}

                        {!loading && rows.length === 0 && (
                            <div style={{ padding: "24px", textAlign: "center" }}>
                                No results found
                            </div>
                        )}
                    </>
                )}
            </div>

            {/* MODAL */}
            {modalType && (
                <div
                    style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 }}
                >
                    <div
                        className="add-task-popup"
                        style={{ width: "600px", background: "#fff", borderRadius: "8px", padding: "20px", boxSizing: "border-box" }}
                    >

                        {/* HEADER */}
                        <div style={{ display: "flex", flexDirection: "row", marginBottom: "5px" }}>

                            <div style={{ width: "50%" }}>
                                <h3 style={{ margin: 0 }}>
                                    {modalType === "delete"
                                        ? `Delete ${selectedRows.length} selected reference(s)`
                                        : `Export ${selectedRows.length} selected reference(s)`
                                    }
                                </h3>
                            </div>

                            <div style={{ width: "50%", textAlign: "right" }}>
                                <button
                                    className="close-button"
                                    onClick={() => setModalType(null)}
                                >
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>

                        </div>

                        {/* BODY */}
                        <div style={{ textAlign: "center", marginTop: "25px", marginBottom: "25px" }}>

                            <div style={{ marginBottom: "15px" }}>
                                {modalType === "delete"
                                    ? "You are about to delete the following items:"
                                    : "You are about to export the following items:"
                                }
                            </div>

                            <div
                                className="thin-scrollbar"
                                style={{ maxHeight: "250px", overflowY: "auto" }}
                            >

                                {selectedRows.map((row) => (
                                    <div
                                        key={row.Id}
                                        style={{ marginBottom: "10px", padding: "5px", backgroundColor: "rgb(242, 242, 242)" }}
                                    >
                                        {row.ProductName}
                                    </div>
                                ))}

                            </div>

                            <br />


                            {actionError && (
                                <div
                                    style={{
                                        color: "rgb(183, 27, 17)",
                                        marginBottom: "15px",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                    }}
                                >
                                    {actionError}
                                </div>
                            )}

                            <div style={{ marginTop: "15px" }}>

                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", gap: "12px" }}>

                                    <div>
                                        <button
                                            className="action-button save-button"
                                            onClick={handleConfirmAction}
                                            disabled={actionLoading}
                                            style={{
                                                padding: "10px 18px",
                                                cursor: actionLoading ? "not-allowed" : "pointer",
                                                opacity: actionLoading ? 0.7 : 1,
                                                minWidth: "120px",
                                            }}
                                        >
                                            {actionLoading ? (
                                                <span
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                    }}
                                                >
                                                    <LoadingSpinnerImage small={true} />
                                                    Processing...
                                                </span>
                                            ) : (
                                                modalType === "delete"
                                                    ? "Delete"
                                                    : "Export"
                                            )}
                                        </button>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            )}
        </div>
    );
};





export default ItemDetailsPane;